<span *ngIf="!showInput">{{ inputModel }}</span>
<input
  #inputElement
  *ngIf="showInput"
  class="outline-0"
  [(ngModel)]="inputModel"
  matInput
  (change)="updateTemplateName($event)"
/>
